// SO version
const icons = {
    close: 'Vitra_Close.svg',
    collection: 'Vitra_Collection.svg',
    down: 'Vitra_Down.svg',
    highlights: 'Vitra_Highlights.svg',
    kids: 'Vitra_Kids.svg',
    menu: 'Vitra_Menu.svg',
    menuOpen: 'Vitra_MenuOpen.svg',
    logo: 'Vitra_MuseumLogo.svg',
    next: 'Vitra_Next.svg',
    prev: 'Vitra_Previous.svg',
    refNumber: 'Vitra_ReferenceNumber.svg',
    save: 'Vitra_Save.svg',
    savePdf: 'Vitra_SavePDF.svg',
    search: 'Vitra_Search.svg',
    share: 'Vitra_Share.svg',
    up: 'Vitra_Up.svg',
};

export default {
    languages: ["de", "en"],
    defaultLanguage: "de",
    navigation: [
        { name: 'objects', url: '/objects' },
        { name: 'designers', url: '/designers' },
        { name: 'producers', url: '/producers' },
        { name: 'objCategories', url: '/contents/Typ' },
        { name: 'objAttributes', url: '/contents/Funktion' },
        { name: 'objMaterials', url: '/contents/Material' },
        { name: 'objUsage', url: '/contents/Verwendung' },
        { name: 'objForKids', url: `/category/${ encodeURIComponent('Für Kinder') }/objects`, icon: icons.kids },
        { name: 'objHighlights', url: `/category/Highlights/objects`, icon: icons.highlights },
        { name: 'myCollection', url: '/mycollection', icon: icons.collection }
    ],
    icons: icons,
    dbCollections: {
        de: {
            objects: "ObjectDE",
            persons: "PersonDE",
            contents: "ContentDE",
            texts: "StaticTextDE",
        },
        fr: {
            objects: "ObjectFR",
            persons: "PersonFR",
            contents: "ContentFR",
            texts: "StaticTextDE",
        },
        en: {
            objects: "ObjectEN",
            persons: "PersonEN",
            contents: "ContentEN",
            texts: "StaticTextEN",
        }
    },
    sortOrder: {
        objects: {
            field: 'ObjObjectNumberTxt',
            dir: 1
        },
        persons: {
            field: 'PerNameSortedTxt',
            dir: 1
        },
        contents: {
            field: 'ConTxt',
            dir: 1
        },
        multimedia: {
            field: 'MulOrder',
            dir: 1
        }
    },
    search: {
        objects: 'ObjObjectNumberTxt',
        persons: 'PerFullText',
        fields: {
            simple: 'searchQuery',
            icon: 'Vitra_ReferenceNumber.svg',
            pattern: '[0-9]{4}',
            className: 'digit',
            maxLength: 4,
        }
    },
    searchResults: {
        showObjects: true,
        showDesigners: false,
        showProducers: false,
    },
    Object: {
        list: {
            showIconBar: true
        },
        detail: {
            showIconBar: true,
            showObjFloorplan: true,
        }
    },
    defaultLimitNumberOfRecords: 1000,
    availableObjectCategories: [
        'ObjObjectNumberTxt',
        'ObjObjectTitleTxt',
        'ObjObjectTitleSubTxt',
        'ObjStandardImage',
        'ObjDesigner',
        'ObjCategoryVoc',
        'ObjDateGrp_DateFromTxt',
        'ObjDateGrp_Notes3Clb',
        'ObjDateGrp_Notes2Clb',
        'ObjDateTxt',
        'ObjMaterialTechniqueTxt',
        'ObjDimension',
        'ObjObjectNumberGrp_Part1Txt',
    ],
    socialSharing: {
        baseUrl: 'http://collection.design-museum.de',
        facebook: true,
        twitter: true,
        googlePlus: false,
        linkedIn: false,
        pinterest: false,
    },
    routesWithVisibleBackLink: [
        '/content/'
    ],
    Person: {
        alphabet: {
            short: [
                'A,Ä,Â,À,B,C',
                'D,E,È,É,Ê,F',
                'G,H',
                'I,Î,Ì,J,K',
                'L,M,N',
                'O,Ö,Ô,P,Q',
                'R,S',
                'T,U,Ü,Û,V',
                'W,X,Y',
                'Z',
            ],
            full: [
                'A,Ä,Â,À',
                'B',
                'C',
                'D',
                'E,È,É,Ê',
                'F',
                'G',
                'H',
                'I,Î,Ì',
                'J',
                'K',
                'L',
                'M',
                'N',
                'O,Ö,Ô',
                'P',
                'Q',
                'R',
                'S',
                'T',
                'U,Ü,Û',
                'V',
                'W',
                'X',
                'Y',
                'Z',
            ],
        },
    },
    expire: {
        after: '12 hours',
        param: 'ref',
        value: 'sd',
        redirectUrl: 'http://collection.design-museum.de',
    },
}


// WEBPACK FOOTER //
// ./config/settings.SD.js